<div
    id="bg_div"
    class="min-h-screen min-w-screen bg-slate-50 p-6 md:px-0 md:py-7"
>
    <div class="mx-auto mb-6 w-full max-w-xl">
        <div class="relative pt-6 sm:pt-0">
            <h2 class="text-lg font-semibold leading-7 text-white md:text-xl">
                {{ getLocalizedText('title') }}
            </h2>
            <p class="mt-1 text-sm leading-6 text-white">
                {{ getLocalizedText('subtitle') }}
            </p>

            <button
                class="rounded-xs absolute -right-2 -top-3 border border-white px-4 font-medium text-white sm:top-1"
                (click)="switchLanguage(currentLanguage === 'en' ? 'zh' : 'en')"
            >
                {{ currentLanguage === 'en' ? 'EN' : '中文' }}
            </button>
        </div>

        <div class="mt-5 h-2 w-full rounded-full bg-blue-200">
            <div
                class="h-full rounded-full text-center text-xs text-white"
                [ngClass]="{
                    'bg-blue-600': currentFormIndex < totalForm,
                    'bg-green-600': currentFormIndex === totalForm,
                }"
                [style.width]="getProgressWidth()"
            ></div>
        </div>
    </div>

    <div class="relative">
        <!-- Form 1 content (employment/application) - now shown as step 2 -->
        <div class="flex justify-center" [ngClass]="getFormClass(1)">
            <form
                [formGroup]="registrationForm"
                class="w-full max-w-xl rounded bg-white p-6 shadow-md md:p-8"
            >
                <div class="space-y-12">
                    <div class="border-b border-gray-900/10 pb-12">
                        <div
                            class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
                        >
                            <!-- How do you know about us? -->
                            <div class="col-span-full">
                                <label
                                    for="where_know_us"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText(
                                            'form_1.howDoYouKnowAboutUs'
                                        )
                                    }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="where_know_us"
                                        formControlName="where_know_us"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('where_know_us'),
                                            'ring-gray-300':
                                                !isFieldInvalid(
                                                    'where_know_us'
                                                ),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="fastjob">
                                            {{
                                                getLocalizedText(
                                                    'form_1.fastjob'
                                                )
                                            }}
                                        </option>
                                        <option value="newspaperAdvertisement">
                                            {{
                                                getLocalizedText(
                                                    'form_1.newspaperAdvertisement'
                                                )
                                            }}
                                        </option>
                                        <option value="onlineJobBoard">
                                            {{
                                                getLocalizedText(
                                                    'form_1.onlineJobBoard'
                                                )
                                            }}
                                        </option>
                                        <option value="companyWebsite">
                                            {{
                                                getLocalizedText(
                                                    'form_1.companyWebsite'
                                                )
                                            }}
                                        </option>
                                        <option value="socialMedia">
                                            {{
                                                getLocalizedText(
                                                    'form_1.socialMedia'
                                                )
                                            }}
                                        </option>
                                        <option value="employeeReferral">
                                            {{
                                                getLocalizedText(
                                                    'form_1.employeeReferral'
                                                )
                                            }}
                                        </option>
                                        <option value="localAdvertisement">
                                            {{
                                                getLocalizedText(
                                                    'form_1.localAdvertisement'
                                                )
                                            }}
                                        </option>
                                        <option value="schoolUniversity">
                                            {{
                                                getLocalizedText(
                                                    'form_1.schoolUniversity'
                                                )
                                            }}
                                        </option>
                                        <option value="wordOfMouth">
                                            {{
                                                getLocalizedText(
                                                    'form_1.wordOfMouth'
                                                )
                                            }}
                                        </option>
                                        <option value="recruitmentAgency">
                                            {{
                                                getLocalizedText(
                                                    'form_1.recruitmentAgency'
                                                )
                                            }}
                                        </option>
                                        <option value="other">
                                            {{
                                                getLocalizedText('common.other')
                                            }}
                                        </option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('where_know_us')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Type of Employment -->
                            <!--                            <div class="col-span-full">-->
                            <!--                                <label for="type_of_employment" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                    {{ getLocalizedText('form_1.typeOfEmployment') }}-->
                            <!--                                </label>-->
                            <!--                                <div class="mt-2">-->
                            <!--                                    <select-->
                            <!--                                        id="type_of_employment"-->
                            <!--                                        formControlName="type_of_employment"-->
                            <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                            <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('type_of_employment'), 'ring-gray-300': !isFieldInvalid('type_of_employment')}">-->
                            <!--                                        <option value="Part-Timer">{{ getLocalizedText('form_1.partTime') }}</option>-->
                            <!--                                    </select>-->
                            <!--                                    <div *ngIf="isFieldInvalid('type_of_employment')" class="text-red-500 text-sm mt-1">-->
                            <!--                                        {{ getLocalizedText('validation.required') }}-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <!-- Position Applied For -->
                            <div class="col-span-full">
                                <label
                                    for="position_applied"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_1.position') }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="position_applied"
                                        formControlName="position_applied"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('where_know_us'),
                                            'ring-gray-300':
                                                !isFieldInvalid(
                                                    'where_know_us'
                                                ),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="Food Operator">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.foodOperator'
                                                )
                                            }}
                                        </option>
                                        <option value="Catering Assistant">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.cateringAssistant'
                                                )
                                            }}
                                        </option>
                                        <option
                                            value="Catering/ Pantry Assistant"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.cateringPantryAssistant'
                                                )
                                            }}
                                        </option>
                                        <option
                                            value="Sales Promoter @ Island wide"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.salesPromoter'
                                                )
                                            }}
                                        </option>
                                        <option
                                            value="Event Catering Service Crew"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.eventCatering'
                                                )
                                            }}
                                        </option>
                                        <option value="Logistics Assistant">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.logisticsAssistant'
                                                )
                                            }}
                                        </option>
                                        <option value="Warehouse Assistant">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.warehouseAssistant'
                                                )
                                            }}
                                        </option>
                                        <option value="Retort Packing">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.retortAdmin'
                                                )
                                            }}
                                        </option>
                                        <option value="MK Admin">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.mkAdmin'
                                                )
                                            }}
                                        </option>
                                        <option value="Project Logistics">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.projectLogistics'
                                                )
                                            }}
                                        </option>
                                        <option value="FnB Service">
                                            {{
                                                getLocalizedText(
                                                    'form_1.positions.fnbService'
                                                )
                                            }}
                                        </option>
                                        <option value="others">
                                            {{
                                                getLocalizedText('common.other')
                                            }}
                                        </option>
                                    </select>
                                    <!--                                    <input-->
                                    <!--                                        type="text"-->
                                    <!--                                        id="position_applied"-->
                                    <!--                                        formControlName="position_applied"-->
                                    <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                                    <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('position_applied'), 'ring-gray-300': !isFieldInvalid('position_applied')}">-->
                                    <div
                                        *ngIf="
                                            isFieldInvalid('position_applied')
                                        "
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Earliest Availability -->
                            <!--                            <div class="col-span-full">-->
                            <!--                                <label for="earliest_availability" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                    {{ getLocalizedText('form_1.availability') }}-->
                            <!--                                </label>-->
                            <!--                                <div class="mt-2">-->
                            <!--                                    <div class="relative">-->
                            <!--                                        <input-->
                            <!--                                            type="text"-->
                            <!--                                            [matDatepicker]="startDatePicker"-->
                            <!--                                            formControlName="earliest_availability"-->
                            <!--                                            placeholder="DD/MM/YYYY"-->
                            <!--                                            [min]="getCurrentDate()"-->
                            <!--                                            class="block w-full rounded-md border border-gray-300 p-1.5 text-gray-900 bg-white"-->
                            <!--                                            [ngClass]="{'border-red-500': isFieldInvalid('earliest_availability'), 'border-gray-300': !isFieldInvalid('earliest_availability')}"-->
                            <!--                                            readonly>-->

                            <!--                                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"-->
                            <!--                                                               class="absolute right-2 top-1/2 -translate-y-1/2">-->
                            <!--                                        </mat-datepicker-toggle>-->
                            <!--                                        <mat-datepicker #startDatePicker></mat-datepicker>-->
                            <!--                                    </div>-->

                            <!--                                    <div *ngIf="isFieldInvalid('earliest_availability')" class="text-red-500 text-sm mt-1">-->
                            <!--                                        {{ getLocalizedText('validation.required') }}-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <!-- Earliest Availability -->
                            <div class="col-span-full">
                                <label
                                    for="earliest_availability"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_1.availability')
                                    }}
                                </label>
                                <div class="mt-2">
                                    <div class="relative">
                                        <input
                                            type="text"
                                            [matDatepicker]="startDatePicker"
                                            formControlName="earliest_availability"
                                            placeholder="DD/MM/YYYY"
                                            [min]="getCurrentDate()"
                                            class="block w-full rounded-md border border-gray-300 bg-white p-1.5 text-gray-900"
                                            [ngClass]="{
                                                'border-red-500':
                                                    isFieldInvalid(
                                                        'earliest_availability'
                                                    ),
                                                'border-gray-300':
                                                    !isFieldInvalid(
                                                        'earliest_availability'
                                                    ),
                                            }"
                                            (dateChange)="
                                                onDateInput2(
                                                    $event.target.value
                                                )
                                            "
                                            required
                                        />

                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="startDatePicker"
                                            class="absolute right-2 top-1/2 -translate-y-1/2"
                                        >
                                        </mat-datepicker-toggle>
                                        <mat-datepicker
                                            #startDatePicker
                                        ></mat-datepicker>
                                    </div>

                                    <div
                                        *ngIf="
                                            isFieldInvalid(
                                                'earliest_availability'
                                            )
                                        "
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Covid-19 Vaccination -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{
                                        getLocalizedText(
                                            'form_1.covidVaccination'
                                        )
                                    }}
                                </legend>
                                <p class="mb-0 text-sm/6 text-gray-600">
                                    {{
                                        getLocalizedText(
                                            'form_1.covidVaccinationDesc'
                                        )
                                    }}
                                </p>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="fully_vaccinated_yes"
                                            formControlName="fully_vaccinated"
                                            type="radio"
                                            [value]="1"
                                            class="appearance-none relative size-4 rounded-full border border-gray-300"
                                        />
                                        <label
                                            for="fully_vaccinated_yes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                        >
                                            {{ getLocalizedText('common.yes') }}
                                        </label>
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="fully_vaccinated_no"
                                            formControlName="fully_vaccinated"
                                            type="radio"
                                            [value]="0"
                                            class="appearance-none relative size-4 rounded-full border border-gray-300"
                                        />
                                        <label
                                            for="fully_vaccinated_no"
                                            class="block text-sm/6 font-medium text-gray-900"
                                        >
                                            {{ getLocalizedText('common.no') }}
                                        </label>
                                    </div>
                                    <div
                                        *ngIf="
                                            isFieldInvalid('fully_vaccinated')
                                        "
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 flex justify-between">
                    <button
                        type="button"
                        (click)="previousForm()"
                        class="text-sm font-semibold leading-6 text-gray-900"
                    >
                        {{ getLocalizedText('common.previous') }}
                    </button>
                    <button
                        type="button"
                        (click)="nextForm()"
                        class="rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline-0"
                    >
                        {{ getLocalizedText('common.next') }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Form 2 content (personal details, contains NRIC/IC) - now shown as step 1 -->
        <div class="flex justify-center" [ngClass]="getFormClass(0)">
            <form
                [formGroup]="registrationForm"
                class="w-full max-w-xl rounded bg-white p-6 shadow-md md:p-8"
            >
                <div class="space-y-12">
                    <div class="border-b border-gray-900/10 pb-12">
                        <div
                            class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
                        >
                            <!-- Full Name -->
                            <div class="col-span-full">
                                <label
                                    for="client_name"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_2.nameAsPerNRIC')
                                    }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="text"
                                        id="client_name"
                                        formControlName="client_name"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('client_name'),
                                            'ring-gray-300':
                                                !isFieldInvalid('client_name'),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('client_name')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Nationality -->
                            <div class="col-span-full">
                                <label
                                    for="nationality"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.nationality') }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="nationality"
                                        formControlName="nationality"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('nationality'),
                                            'ring-gray-300':
                                                !isFieldInvalid('nationality'),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="Singaporean">
                                            Singaporean
                                        </option>
                                        <option value="Singapore PR">
                                            Singapore PR
                                        </option>
                                        <option value="Malaysian">
                                            Malaysian
                                        </option>
                                        <option value="Chinese">Chinese</option>
                                        <option value="OTHER">Other</option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('nationality')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- PR Start Date (conditional) -->
                            <!--                            <div class="col-span-full" *ngIf="registrationForm.get('nationality')?.value === 'Singapore PR'">-->
                            <!--                                <label for="pr_start_date" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                    {{ getLocalizedText('form_2.prStartDate') }}-->
                            <!--                                </label>-->
                            <!--                                <div class="mt-2">-->
                            <!--                                    <input-->
                            <!--                                        type="date"-->
                            <!--                                        id="pr_start_date"-->
                            <!--                                        formControlName="pr_start_date"-->
                            <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                            <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('pr_start_date'), 'ring-gray-300': !isFieldInvalid('pr_start_date')}">-->
                            <!--                                    <div *ngIf="isFieldInvalid('pr_start_date')" class="text-red-500 text-sm mt-1">-->
                            <!--                                        {{ getLocalizedText('validation.required') }}-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <div
                                class="col-span-full"
                                *ngIf="
                                    registrationForm.get('nationality')
                                        ?.value === 'Singapore PR'
                                "
                            >
                                <label
                                    for="pr_start_date"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.prStartDate') }}
                                </label>
                                <div class="mt-2">
                                    <div class="relative">
                                        <input
                                            type="text"
                                            id="pr_start_date"
                                            [matDatepicker]="prStartDatePicker"
                                            formControlName="pr_start_date"
                                            placeholder="DD/MM/YYYY"
                                            class="block w-full rounded-md border-0 p-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset"
                                            [ngClass]="{
                                                'ring-red-500':
                                                    isFieldInvalid(
                                                        'pr_start_date'
                                                    ),
                                                'ring-gray-300':
                                                    !isFieldInvalid(
                                                        'pr_start_date'
                                                    ),
                                            }"
                                            (dateChange)="
                                                onDateInputAll(
                                                    $event.target.value,
                                                    'pr_start_date'
                                                )
                                            "
                                        />

                                        <mat-datepicker-toggle
                                            [for]="prStartDatePicker"
                                            class="absolute right-1 top-1/2 z-10 -translate-y-1/2"
                                        >
                                        </mat-datepicker-toggle>
                                        <mat-datepicker
                                            #prStartDatePicker
                                        ></mat-datepicker>
                                    </div>

                                    <div
                                        *ngIf="isFieldInvalid('pr_start_date')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- ID Type -->
                            <div class="col-span-full">
                                <label
                                    for="id_type"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.idType') }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="id_type"
                                        formControlName="id_type"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('id_type'),
                                            'ring-gray-300':
                                                !isFieldInvalid('id_type'),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="NRIC">
                                            Singapore NRIC
                                        </option>
                                        <option value="FIN">
                                            Singapore FIN
                                        </option>
                                        <option value="MY_IC">
                                            Malaysian IC
                                        </option>
                                        <option value="CN_IC">
                                            Chinese ID
                                        </option>
                                        <option value="Passport">
                                            Passport
                                        </option>
                                        <option value="OTHER">Other ID</option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('id_type')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- NRIC/FIN/Passport Number -->
                            <div class="col-span-full">
                                <label
                                    for="id_number"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.idNumber') }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="text"
                                        id="id_number"
                                        formControlName="id_number"
                                        (blur)="onIcBlur()"
                                        (input)="onIcInputChange()"
                                        class="block w-full rounded-md border-0 p-1.5 uppercase text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('id_number'),
                                            'ring-gray-300':
                                                !isFieldInvalid('id_number'),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('id_number')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'id_number'
                                                )?.errors?.['required']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </span>
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'id_number'
                                                )?.errors?.['pattern']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.pattern.id'
                                                )
                                            }}
                                        </span>
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'id_number'
                                                )?.errors?.['checksum']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.invalid.nric'
                                                )
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- IC lookup / duplicate check (step 1) -->
                            <div class="col-span-full">
                                <button
                                    type="button"
                                    (click)="checkIc()"
                                    [disabled]="icCheckStatus === 'checking'"
                                    class="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    {{
                                        icCheckStatus === 'checking'
                                            ? getLocalizedText(
                                                  'ic_check.checking'
                                              )
                                            : getLocalizedText(
                                                  'ic_check.checkButton'
                                              )
                                    }}
                                </button>

                                <!-- ACTIVE: existing record found -->
                                <div
                                    *ngIf="icCheckStatus === 'active'"
                                    class="mt-3 rounded-md border border-green-300 bg-green-50 p-3 text-sm text-green-800"
                                >
                                    {{
                                        getLocalizedText('ic_check.foundActive')
                                    }}
                                </div>

                                <!-- PENDING / REJECTED: informational, non-blocking resubmission -->
                                <div
                                    *ngIf="
                                        icCheckStatus === 'pending' ||
                                        icCheckStatus === 'rejected'
                                    "
                                    class="mt-3 rounded-md border border-blue-300 bg-blue-50 p-3 text-sm text-blue-800"
                                >
                                    {{ getLocalizedText(icCheckMessageKey) }}
                                </div>

                                <!-- Blocking states: blacklisted / other status / possible legacy -->
                                <div
                                    *ngIf="icHardBlocked"
                                    class="mt-3 rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-800"
                                >
                                    {{ getLocalizedText(icCheckMessageKey) }}
                                </div>

                                <!-- Transport error: blocks progression, retry via Check IC -->
                                <div
                                    *ngIf="icCheckStatus === 'error'"
                                    class="mt-3 rounded-md border border-yellow-300 bg-yellow-50 p-3 text-sm text-yellow-800"
                                >
                                    {{ getLocalizedText('ic_check.error') }}
                                </div>
                            </div>

                            <!-- Passport Expiry Date (shown only if ID Type is Passport) -->
                            <!--                            <div class="col-span-full" *ngIf="registrationForm.get('id_type')?.value === 'Passport'">-->
                            <!--                                <label for="passport_expiry" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                    {{ getLocalizedText('form_2.passportExpiry') }}-->
                            <!--                                </label>-->
                            <!--                                <div class="mt-2">-->
                            <!--                                    <input-->
                            <!--                                        type="date"-->
                            <!--                                        id="passport_expiry"-->
                            <!--                                        formControlName="passport_expiry"-->
                            <!--                                        [min]="getCurrentDate()"-->
                            <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                            <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('passport_expiry'), 'ring-gray-300': !isFieldInvalid('passport_expiry')}">-->
                            <!--                                    <div *ngIf="isFieldInvalid('passport_expiry')" class="text-red-500 text-sm mt-1">-->
                            <!--                                        {{ getLocalizedText('validation.required') }}-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div
                                class="col-span-full"
                                *ngIf="
                                    registrationForm.get('id_type')?.value ===
                                    'Passport'
                                "
                            >
                                <label
                                    for="passport_expiry"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText(
                                            'form_2.passportExpiry'
                                        )
                                    }}
                                </label>
                                <div class="mt-2">
                                    <div class="relative">
                                        <input
                                            type="text"
                                            id="passport_expiry"
                                            [matDatepicker]="
                                                passportExpiryPicker
                                            "
                                            formControlName="passport_expiry"
                                            placeholder="DD/MM/YYYY"
                                            [min]="getCurrentDate()"
                                            class="block w-full rounded-md border-0 p-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset"
                                            [ngClass]="{
                                                'ring-red-500':
                                                    isFieldInvalid(
                                                        'passport_expiry'
                                                    ),
                                                'ring-gray-300':
                                                    !isFieldInvalid(
                                                        'passport_expiry'
                                                    ),
                                            }"
                                            (dateChange)="
                                                onDateInputAll(
                                                    $event.target.value,
                                                    'passport_expiry'
                                                )
                                            "
                                        />

                                        <mat-datepicker-toggle
                                            [for]="passportExpiryPicker"
                                            class="absolute right-1 top-1/2 z-10 -translate-y-1/2"
                                        >
                                        </mat-datepicker-toggle>
                                        <mat-datepicker
                                            #passportExpiryPicker
                                        ></mat-datepicker>
                                    </div>

                                    <div
                                        *ngIf="
                                            isFieldInvalid('passport_expiry')
                                        "
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- NRIC -->
                            <!--                            <div class="col-span-full">-->
                            <!--                                <label for="nric" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                    {{ getLocalizedText('form_2.nricNumber') }}-->
                            <!--                                </label>-->
                            <!--                                <div class="mt-2">-->
                            <!--                                    <input-->
                            <!--                                        type="text"-->
                            <!--                                        id="nric"-->
                            <!--                                        formControlName="nric"-->
                            <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset uppercase"-->
                            <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('nric'), 'ring-gray-300': !isFieldInvalid('nric')}">-->
                            <!--                                    <div *ngIf="isFieldInvalid('nric')" class="text-red-500 text-sm mt-1">-->
                            <!--                                <span *ngIf="registrationForm.get('nric')?.errors?.['required']">-->
                            <!--                                    {{ getLocalizedText('validation.required') }}-->
                            <!--                                </span>-->
                            <!--                                        <span *ngIf="registrationForm.get('nric')?.errors?.['pattern']">-->
                            <!--                                    {{ getLocalizedText('validation.pattern.nric') }}-->
                            <!--                                </span>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <!-- Contact Number -->
                            <div class="col-span-full">
                                <label
                                    for="contact_number"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_2.contactNumber')
                                    }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="tel"
                                        id="contact_number"
                                        formControlName="contact_number"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid(
                                                    'contact_number'
                                                ),
                                            'ring-gray-300':
                                                !isFieldInvalid(
                                                    'contact_number'
                                                ),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('contact_number')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'contact_number'
                                                )?.errors?.['required']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </span>
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'contact_number'
                                                )?.errors?.['pattern']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.pattern.phone'
                                                )
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Date of Birth -->
                            <!--                            <div class="col-span-full">-->
                            <!--                                <label for="date_of_birth" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                    {{ getLocalizedText('form_2.dob') }}-->
                            <!--                                </label>-->
                            <!--                                <div class="mt-2">-->
                            <!--                                    <input-->
                            <!--                                        type="date"-->
                            <!--                                        id="date_of_birth"-->
                            <!--                                        formControlName="date_of_birth"-->
                            <!--                                        [max]="getCurrentDate()"-->
                            <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                            <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('date_of_birth'), 'ring-gray-300': !isFieldInvalid('date_of_birth')}">-->
                            <!--                                    <div *ngIf="isFieldInvalid('date_of_birth')" class="text-red-500 text-sm mt-1">-->
                            <!--                                        {{ getLocalizedText('validation.required') }}-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <!-- Date of Birth -->
                            <div class="col-span-full">
                                <label
                                    for="date_of_birth"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.dob') }}
                                </label>
                                <div class="mt-2">
                                    <!-- Input container with fixed height to prevent shifting -->
                                    <div class="relative">
                                        <input
                                            type="text"
                                            id="date_of_birth"
                                            [matDatepicker]="dobDatePicker"
                                            formControlName="date_of_birth"
                                            placeholder="DD/MM/YYYY"
                                            [max]="getCurrentDate()"
                                            class="block w-full rounded-md border-0 p-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset"
                                            [ngClass]="{
                                                'ring-red-500':
                                                    isFieldInvalid(
                                                        'date_of_birth'
                                                    ),
                                                'ring-gray-300':
                                                    !isFieldInvalid(
                                                        'date_of_birth'
                                                    ),
                                            }"
                                            (dateChange)="
                                                onDateInputAll(
                                                    $event.target.value,
                                                    'date_of_birth'
                                                )
                                            "
                                        />

                                        <!-- Fixed position for the datepicker toggle -->
                                        <mat-datepicker-toggle
                                            [for]="dobDatePicker"
                                            class="absolute right-1 top-1/2 z-10 -translate-y-1/2"
                                        >
                                        </mat-datepicker-toggle>
                                        <mat-datepicker
                                            #dobDatePicker
                                        ></mat-datepicker>
                                    </div>

                                    <!-- Validation Messages -->
                                    <div
                                        *ngIf="
                                            registrationForm.get(
                                                'date_of_birth'
                                            )?.touched
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                registrationForm.get(
                                                    'date_of_birth'
                                                )?.errors?.['required']
                                            "
                                            class="mt-1 text-sm text-red-500"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </div>
                                        <div
                                            *ngIf="
                                                registrationForm.get(
                                                    'date_of_birth'
                                                )?.errors?.['ageInvalid']
                                            "
                                            class="mt-1 text-sm text-red-500"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.age.too_young'
                                                )
                                            }}
                                        </div>
                                    </div>

                                    <!-- Document requirement notification -->
                                    <!--                                    <div *ngIf="requiresDocument" class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-2">-->
                                    <!--                                        <div class="flex">-->
                                    <!--                                            <div class="flex-shrink-0">-->
                                    <!--                                                <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">-->
                                    <!--                                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>-->
                                    <!--                                                </svg>-->
                                    <!--                                            </div>-->
                                    <!--                                            <div class="ml-3">-->
                                    <!--                                                <p class="text-sm text-yellow-700">-->
                                    <!--                                                    {{ getLocalizedText('validation.age.document_required') }}-->
                                    <!--                                                </p>-->
                                    <!--                                            </div>-->
                                    <!--                                        </div>-->
                                    <!--                                    </div>-->
                                </div>
                            </div>

                            <!-- Place of Birth -->
                            <div class="col-span-full">
                                <label
                                    for="place_of_birth"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_2.placeOfBirth')
                                    }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="text"
                                        id="place_of_birth"
                                        formControlName="place_of_birth"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid(
                                                    'place_of_birth'
                                                ),
                                            'ring-gray-300':
                                                !isFieldInvalid(
                                                    'place_of_birth'
                                                ),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('place_of_birth')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Age -->
                            <div class="col-span-full">
                                <label
                                    for="age"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.age') }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="number"
                                        id="age"
                                        formControlName="age"
                                        min="15"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        readonly
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('age'),
                                            'ring-gray-300':
                                                !isFieldInvalid('age'),
                                        }"
                                    />
                                    <div
                                        *ngIf="
                                            registrationForm.get('age')
                                                ?.touched &&
                                            registrationForm.get('age')
                                                ?.errors?.['minAge']
                                        "
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.age.minimum'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Gender -->
                            <div class="col-span-full">
                                <label
                                    for="gender"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.gender') }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="gender"
                                        formControlName="gender"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('gender'),
                                            'ring-gray-300':
                                                !isFieldInvalid('gender'),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="Male">
                                            {{
                                                getLocalizedText('form_2.male')
                                            }}
                                        </option>
                                        <option value="Female">
                                            {{
                                                getLocalizedText(
                                                    'form_2.female'
                                                )
                                            }}
                                        </option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('gender')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Unit Number -->
                            <div class="col-span-full">
                                <label
                                    for="unit_number"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_2.unitNumber') ||
                                            'Unit Number'
                                    }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="text"
                                        id="unit_number"
                                        formControlName="unit_number"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300"
                                        [ngClass]="{ 'ring-gray-300': true }"
                                    />
                                    <div class="mt-1 text-xs text-gray-500">
                                        {{
                                            getLocalizedText(
                                                'form_2.unitNumberHint'
                                            ) ||
                                                'Only needed if the unit number is not shown in the address below. Leave empty otherwise.'
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Residential Address -->
                            <div class="col-span-full">
                                <div
                                    class="mb-1 flex items-center justify-between"
                                >
                                    <label
                                        for="residential_address"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_2.residentialAddress'
                                            )
                                        }}
                                    </label>
                                    <button
                                        type="button"
                                        mat-button
                                        color="primary"
                                        class="-mt-2 h-8 text-xs"
                                        (click)="toggleAddressMode()"
                                    >
                                        {{
                                            addressMode === 'single'
                                                ? 'Advanced Options'
                                                : 'Simple View'
                                        }}
                                    </button>
                                </div>
                                <div class="mt-2">
                                    <app-address-autocomplete
                                        [placeholder]="
                                            'Search or enter address'
                                        "
                                        [mode]="addressMode"
                                        [countryRestriction]="['MY', 'SG']"
                                        [requirePostalCode]="true"
                                        [requireCoordinates]="true"
                                        [required]="true"
                                        [ngModel]="temporaryAddress"
                                        [ngModelOptions]="{ standalone: true }"
                                        (addressChanged)="
                                            onAddressChanged($event)
                                        "
                                        (validationChanged)="
                                            onAddressValidationChanged($event)
                                        "
                                    ></app-address-autocomplete>
                                    <div class="mt-1 text-xs text-gray-500">
                                        {{
                                            addressMode === 'single'
                                                ? 'Search for an address or use advanced options for detailed entry, kindly provide postal code as well'
                                                : 'Enter address details manually or use the search field above'
                                        }}
                                    </div>

                                    <!-- Hidden fields for form validation -->
                                    <input
                                        type="hidden"
                                        id="residential_address"
                                        formControlName="residential_address"
                                    />
                                    <input
                                        type="hidden"
                                        id="postal_code"
                                        formControlName="postal_code"
                                    />

                                    <!-- Only show the error messages when not related to postal code or coordinates -->
                                    <div
                                        *ngIf="
                                            isFieldInvalid(
                                                'residential_address'
                                            ) &&
                                            !registrationForm.get(
                                                'residential_address'
                                            )?.value
                                        "
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Postal Code UI has been removed, now handled by Google Places Autocomplete -->

                            <!-- Email -->
                            <div class="col-span-full">
                                <label
                                    for="contact_email"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.email') }}
                                </label>
                                <div class="mt-2">
                                    <input
                                        type="email"
                                        id="contact_email"
                                        formControlName="contact_email"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('contact_email'),
                                            'ring-gray-300':
                                                !isFieldInvalid(
                                                    'contact_email'
                                                ),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('contact_email')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'contact_email'
                                                )?.errors?.['required']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </span>
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'contact_email'
                                                )?.errors?.['email']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.email'
                                                )
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Race -->
                            <div class="col-span-full">
                                <label
                                    for="race"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.race') }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="race"
                                        formControlName="race"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('race'),
                                            'ring-gray-300':
                                                !isFieldInvalid('race'),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="chinese">
                                            {{
                                                getLocalizedText(
                                                    'form_2.races.chinese'
                                                )
                                            }}
                                        </option>
                                        <option value="malay">
                                            {{
                                                getLocalizedText(
                                                    'form_2.races.malay'
                                                )
                                            }}
                                        </option>
                                        <option value="indian">
                                            {{
                                                getLocalizedText(
                                                    'form_2.races.indian'
                                                )
                                            }}
                                        </option>
                                        <option value="eurasian">
                                            {{
                                                getLocalizedText(
                                                    'form_2.races.eurasian'
                                                )
                                            }}
                                        </option>
                                        <option value="other">
                                            {{
                                                getLocalizedText(
                                                    'form_2.races.other'
                                                )
                                            }}
                                        </option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('race')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Religion -->
                            <div class="col-span-full">
                                <label
                                    for="religion"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_2.religion') }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="religion"
                                        formControlName="religion"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('religion'),
                                            'ring-gray-300':
                                                !isFieldInvalid('religion'),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="buddhist">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.buddhist'
                                                )
                                            }}
                                        </option>
                                        <option value="christian">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.christian'
                                                )
                                            }}
                                        </option>
                                        <option value="catholic">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.catholic'
                                                )
                                            }}
                                        </option>
                                        <option value="muslim">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.muslim'
                                                )
                                            }}
                                        </option>
                                        <option value="hindu">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.hindu'
                                                )
                                            }}
                                        </option>
                                        <option value="sikh">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.sikh'
                                                )
                                            }}
                                        </option>
                                        <option value="freethinker">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.freethinker'
                                                )
                                            }}
                                        </option>
                                        <option value="other">
                                            {{
                                                getLocalizedText(
                                                    'form_2.religions.other'
                                                )
                                            }}
                                        </option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('religion')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- Marital Status -->
                            <div class="col-span-full">
                                <label
                                    for="marital_status"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_2.maritalStatus')
                                    }}
                                </label>
                                <div class="mt-2">
                                    <select
                                        id="marital_status"
                                        formControlName="marital_status"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid(
                                                    'marital_status'
                                                ),
                                            'ring-gray-300':
                                                !isFieldInvalid(
                                                    'marital_status'
                                                ),
                                        }"
                                    >
                                        <option value="">
                                            {{
                                                getLocalizedText(
                                                    'common.pleaseSelect'
                                                )
                                            }}
                                        </option>
                                        <option value="single">
                                            {{
                                                getLocalizedText(
                                                    'form_2.maritalStatuses.single'
                                                )
                                            }}
                                        </option>
                                        <option value="married">
                                            {{
                                                getLocalizedText(
                                                    'form_2.maritalStatuses.married'
                                                )
                                            }}
                                        </option>
                                        <option value="divorced">
                                            {{
                                                getLocalizedText(
                                                    'form_2.maritalStatuses.divorced'
                                                )
                                            }}
                                        </option>
                                        <option value="widowed">
                                            {{
                                                getLocalizedText(
                                                    'form_2.maritalStatuses.widowed'
                                                )
                                            }}
                                        </option>
                                    </select>
                                    <div
                                        *ngIf="isFieldInvalid('marital_status')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 flex justify-end">
                    <button
                        type="button"
                        (click)="nextForm()"
                        [disabled]="icNextDisabled"
                        class="rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        {{ getLocalizedText('common.next') }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Form 3 content -->
        <div class="flex justify-center" [ngClass]="getFormClass(2)">
            <form
                [formGroup]="registrationForm"
                class="w-full max-w-xl rounded bg-white p-6 shadow-md md:p-8"
            >
                <div class="space-y-12">
                    <div class="border-b border-gray-900/10 pb-12">
                        <div
                            class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
                        >
                            <!-- Employee Certificates Manager -->
                            <div class="col-span-full">
                                <app-employee-certificates-manager
                                    [certificates]="employeeCertificates"
                                    [readonly]="false"
                                    (certificatesChange)="
                                        onCertificatesChange($event)
                                    "
                                >
                                </app-employee-certificates-manager>
                            </div>

                            <!-- Next of Kin -->
                            <div
                                class="col-span-full border-t border-gray-900/10 pt-6"
                            >
                                <p
                                    class="text-base font-semibold leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_3.nextOfKin') }}
                                </p>
                                <label
                                    for="kin_name"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                    >{{
                                        getLocalizedText('form_3.nextOfKinName')
                                    }}</label
                                >
                                <div class="mt-2">
                                    <input
                                        type="text"
                                        id="kin_name"
                                        formControlName="kin_name"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('kin_name'),
                                            'ring-gray-300':
                                                !isFieldInvalid('kin_name'),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('kin_name')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-span-full">
                                <label
                                    for="kin_contact"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                    >{{
                                        getLocalizedText(
                                            'form_3.nextOfKinContact'
                                        )
                                    }}</label
                                >
                                <div class="mt-2">
                                    <input
                                        type="tel"
                                        id="kin_contact"
                                        formControlName="kin_contact"
                                        maxlength="15"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('kin_contact'),
                                            'ring-gray-300':
                                                !isFieldInvalid('kin_contact'),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('kin_contact')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'kin_contact'
                                                )?.errors?.['required']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </span>
                                        <span
                                            *ngIf="
                                                registrationForm.get(
                                                    'kin_contact'
                                                )?.errors?.['pattern']
                                            "
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.pattern.phone'
                                                )
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Bank Details -->
                            <div
                                class="col-span-full border-t border-gray-900/10 pt-6"
                            >
                                <p
                                    class="text-base font-semibold leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_3.bankDetails') }}
                                </p>
                                <label
                                    for="bank_name"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                    >{{
                                        getLocalizedText('form_3.bankName')
                                    }}</label
                                >
                                <div class="relative mt-2">
                                    <input
                                        type="text"
                                        id="bank_name"
                                        formControlName="bank_name"
                                        (input)="
                                            onBankSearch(
                                                $any($event.target).value
                                            )
                                        "
                                        (focus)="openBankDropdown()"
                                        (blur)="closeBankDropdown()"
                                        placeholder="Search bank..."
                                        autocomplete="off"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('bank_name'),
                                            'ring-gray-300':
                                                !isFieldInvalid('bank_name'),
                                        }"
                                    />

                                    <div
                                        *ngIf="
                                            showBankDropdown &&
                                            filteredBankList.length > 0
                                        "
                                        class="absolute z-20 mt-1 max-h-60 w-full overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                                    >
                                        <div
                                            *ngFor="
                                                let bank of filteredBankList
                                            "
                                            (mousedown)="selectBank(bank)"
                                            class="cursor-pointer select-none px-3 py-2 text-sm text-gray-900 hover:bg-orange-50 hover:text-orange-700"
                                        >
                                            {{ bank }}
                                        </div>
                                    </div>

                                    <div
                                        *ngIf="
                                            showBankDropdown &&
                                            filteredBankList.length === 0
                                        "
                                        class="absolute z-20 mt-1 w-full rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                                    >
                                        <div
                                            class="px-3 py-2 text-sm text-gray-500"
                                        >
                                            No banks found
                                        </div>
                                    </div>

                                    <div
                                        *ngIf="isFieldInvalid('bank_name')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-span-full">
                                <label
                                    for="bank_acc"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                    >{{
                                        getLocalizedText('form_3.accountNumber')
                                    }}</label
                                >
                                <div class="mt-2">
                                    <input
                                        id="bank_acc"
                                        formControlName="bank_acc"
                                        placeholder="Bank Acc"
                                        maxlength="15"
                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                        [ngClass]="{
                                            'ring-red-500':
                                                isFieldInvalid('bank_acc'),
                                            'ring-gray-300':
                                                !isFieldInvalid('bank_acc'),
                                        }"
                                    />
                                    <div
                                        *ngIf="isFieldInvalid('bank_acc')"
                                        class="mt-1 text-sm text-red-500"
                                    >
                                        {{
                                            getLocalizedText(
                                                'validation.required'
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 flex justify-between">
                    <button
                        type="button"
                        (click)="previousForm()"
                        class="text-sm font-semibold leading-6 text-gray-900"
                    >
                        Previous
                    </button>
                    <button
                        type="button"
                        (click)="nextForm()"
                        class="rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline-0"
                    >
                        Next
                    </button>
                </div>
            </form>
        </div>

        <!-- Form 4 content -->
        <div class="flex justify-center" [ngClass]="getFormClass(3)">
            <form
                [formGroup]="registrationForm"
                class="w-full max-w-xl rounded bg-white p-6 shadow-md md:p-8"
            >
                <div class="space-y-12">
                    <div class="border-b border-gray-900/10 pb-12">
                        <h2
                            class="mb-6 text-base font-semibold leading-7 text-gray-900"
                        >
                            {{ getLocalizedText('form_4.workingExperience') }}
                        </h2>

                        <!-- Working Experience Form Array -->
                        <div formArrayName="working_exps">
                            <div
                                *ngFor="
                                    let exp of workingExps.controls;
                                    let i = index
                                "
                                [formGroupName]="i"
                                class="mt-8 border-t border-gray-200 pt-8 first:mt-0 first:border-0 first:pt-0"
                            >
                                <div
                                    class="mb-4 flex items-center justify-between"
                                >
                                    <h3
                                        class="text-sm font-semibold text-gray-900"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_4.experience'
                                            )
                                        }}
                                        #{{ i + 1 }}
                                    </h3>
                                    <button
                                        *ngIf="i > 0"
                                        type="button"
                                        (click)="removeWorkingExperience(i)"
                                        class="text-sm text-red-600 hover:text-red-800"
                                    >
                                        {{ getLocalizedText('common.remove') }}
                                    </button>
                                </div>

                                <!-- Company Name -->
                                <div class="mb-4">
                                    <label
                                        [for]="'company_' + i"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_4.previousCompanyName'
                                            )
                                        }}
                                    </label>
                                    <div class="mt-2">
                                        <input
                                            [id]="'company_' + i"
                                            type="text"
                                            formControlName="previous_company_name"
                                            class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                            [ngClass]="{
                                                'ring-red-500':
                                                    isWorkingExpFieldInvalid(
                                                        i,
                                                        'previous_company_name'
                                                    ),
                                                'ring-gray-300':
                                                    !isWorkingExpFieldInvalid(
                                                        i,
                                                        'previous_company_name'
                                                    ),
                                            }"
                                        />
                                        <div
                                            *ngIf="
                                                isWorkingExpFieldInvalid(
                                                    i,
                                                    'previous_company_name'
                                                )
                                            "
                                            class="mt-1 text-sm text-red-500"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Position -->
                                <div class="mb-4">
                                    <label
                                        [for]="'position_' + i"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_4.previousPosition'
                                            )
                                        }}
                                    </label>
                                    <div class="mt-2">
                                        <input
                                            [id]="'position_' + i"
                                            type="text"
                                            formControlName="position"
                                            class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                            [ngClass]="{
                                                'ring-red-500':
                                                    isWorkingExpFieldInvalid(
                                                        i,
                                                        'position'
                                                    ),
                                                'ring-gray-300':
                                                    !isWorkingExpFieldInvalid(
                                                        i,
                                                        'position'
                                                    ),
                                            }"
                                        />
                                        <div
                                            *ngIf="
                                                isWorkingExpFieldInvalid(
                                                    i,
                                                    'position'
                                                )
                                            "
                                            class="mt-1 text-sm text-red-500"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Date Range -->
                                <div
                                    class="grid grid-cols-1 gap-4 sm:grid-cols-2"
                                >
                                    <!-- Start Date -->
                                    <div>
                                        <label
                                            [for]="'start_date_' + i"
                                            class="block text-sm font-medium leading-6 text-gray-900"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'form_4.dateStart'
                                                )
                                            }}
                                        </label>
                                        <!--                                        <div class="mt-2">-->
                                        <!--                                            <input-->
                                        <!--                                                [id]="'start_date_' + i"-->
                                        <!--                                                type="date"-->
                                        <!--                                                formControlName="date_start"-->
                                        <!--                                                class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                                        <!--                                                [ngClass]="{'ring-red-500': isWorkingExpFieldInvalid(i, 'date_start'), 'ring-gray-300': !isWorkingExpFieldInvalid(i, 'date_start')}">-->
                                        <!--                                            <div *ngIf="isWorkingExpFieldInvalid(i, 'date_start')" class="text-red-500 text-sm mt-1">-->
                                        <!--                                                {{ getLocalizedText('validation.required') }}-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->
                                        <div class="mt-2">
                                            <div class="relative">
                                                <input
                                                    type="text"
                                                    [id]="'start_date_' + i"
                                                    [matDatepicker]="picker"
                                                    formControlName="date_start"
                                                    placeholder="DD/MM/YYYY"
                                                    class="block w-full rounded-md border-0 p-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset"
                                                    [ngClass]="{
                                                        'ring-red-500':
                                                            isWorkingExpFieldInvalid(
                                                                i,
                                                                'date_start'
                                                            ),
                                                        'ring-gray-300':
                                                            !isWorkingExpFieldInvalid(
                                                                i,
                                                                'date_start'
                                                            ),
                                                    }"
                                                    (dateChange)="
                                                        onDateInputAllForm(
                                                            $event.target.value,
                                                            i,
                                                            'date_start'
                                                        )
                                                    "
                                                />

                                                <mat-datepicker-toggle
                                                    [for]="picker"
                                                    class="absolute right-1 top-1/2 z-10 -translate-y-1/2"
                                                >
                                                </mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker
                                                ></mat-datepicker>
                                            </div>

                                            <div
                                                *ngIf="
                                                    isWorkingExpFieldInvalid(
                                                        i,
                                                        'date_start'
                                                    )
                                                "
                                                class="mt-1 text-sm text-red-500"
                                            >
                                                {{
                                                    getLocalizedText(
                                                        'validation.required'
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- End Date -->
                                    <div>
                                        <label
                                            [for]="'end_date_' + i"
                                            class="block text-sm font-medium leading-6 text-gray-900"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'form_4.dateLeft'
                                                )
                                            }}
                                        </label>
                                        <!--                                        <div class="mt-2">-->
                                        <!--                                            <input-->
                                        <!--                                                [id]="'end_date_' + i"-->
                                        <!--                                                type="date"-->
                                        <!--                                                formControlName="date_left"-->
                                        <!--                                                class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                                        <!--                                                [ngClass]="{'ring-red-500': isWorkingExpFieldInvalid(i, 'date_left'), 'ring-gray-300': !isWorkingExpFieldInvalid(i, 'date_left')}">-->
                                        <!--                                            <div *ngIf="isWorkingExpFieldInvalid(i, 'date_left')" class="text-red-500 text-sm mt-1">-->
                                        <!--                                                {{ getLocalizedText('validation.required') }}-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->
                                        <div class="mt-2">
                                            <div class="relative">
                                                <input
                                                    type="text"
                                                    [id]="'end_date_' + i"
                                                    [matDatepicker]="endPicker"
                                                    formControlName="date_left"
                                                    placeholder="DD/MM/YYYY"
                                                    class="block w-full rounded-md border-0 p-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset"
                                                    [ngClass]="{
                                                        'ring-red-500':
                                                            isWorkingExpFieldInvalid(
                                                                i,
                                                                'date_left'
                                                            ),
                                                        'ring-gray-300':
                                                            !isWorkingExpFieldInvalid(
                                                                i,
                                                                'date_left'
                                                            ),
                                                    }"
                                                    (dateChange)="
                                                        onDateInputAllForm(
                                                            $event.target.value,
                                                            i,
                                                            'date_left'
                                                        )
                                                    "
                                                />

                                                <mat-datepicker-toggle
                                                    [for]="endPicker"
                                                    class="absolute right-1 top-1/2 z-10 -translate-y-1/2"
                                                >
                                                </mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #endPicker
                                                ></mat-datepicker>
                                            </div>

                                            <div
                                                *ngIf="
                                                    isWorkingExpFieldInvalid(
                                                        i,
                                                        'date_left'
                                                    )
                                                "
                                                class="mt-1 text-sm text-red-500"
                                            >
                                                {{
                                                    getLocalizedText(
                                                        'validation.required'
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Reason for Leaving -->
                                <div class="mt-4">
                                    <label
                                        [for]="'reason_' + i"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_4.reasonForLeaving'
                                            )
                                        }}
                                    </label>
                                    <div class="mt-2">
                                        <textarea
                                            [id]="'reason_' + i"
                                            formControlName="reason_for_leaving"
                                            rows="3"
                                            class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                            [ngClass]="{
                                                'ring-red-500':
                                                    isWorkingExpFieldInvalid(
                                                        i,
                                                        'reason_for_leaving'
                                                    ),
                                                'ring-gray-300':
                                                    !isWorkingExpFieldInvalid(
                                                        i,
                                                        'reason_for_leaving'
                                                    ),
                                            }"
                                        >
                                        </textarea>
                                        <div
                                            *ngIf="
                                                isWorkingExpFieldInvalid(
                                                    i,
                                                    'reason_for_leaving'
                                                )
                                            "
                                            class="mt-1 text-sm text-red-500"
                                        >
                                            {{
                                                getLocalizedText(
                                                    'validation.required'
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Add Experience Button -->
                        <button
                            type="button"
                            (click)="addWorkingExperience()"
                            class="mt-4 inline-flex items-center gap-x-2 rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >
                            <svg
                                class="-ml-0.5 h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
                                />
                            </svg>
                            {{ getLocalizedText('form_4.addExperience') }}
                        </button>

                        <div class="my-6 border-t border-gray-200"></div>

                        <!-- Highest Qualification -->
                        <!--                        <div class="col-span-full pt-6">-->
                        <!--                            <label for="highest_education" class="block text-sm font-medium leading-6 text-gray-900">-->
                        <!--                                {{ getLocalizedText('form_4.highestQualification') }}-->
                        <!--                            </label>-->
                        <!--                            <div class="mt-2">-->
                        <!--                                <select-->
                        <!--                                    id="highest_education"-->
                        <!--                                    formControlName="highest_education"-->
                        <!--                                    class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                        <!--                                    [ngClass]="{'ring-red-500': isFieldInvalid('highest_education'), 'ring-gray-300': !isFieldInvalid('highest_education')}">-->
                        <!--                                    <option value="">{{ getLocalizedText('common.pleaseSelect') }}</option>-->
                        <!--                                    <option value="SPM">{{ getLocalizedText('form_4.spm') }}</option>-->
                        <!--                                    <option value="STPM">{{ getLocalizedText('form_4.stpm') }}</option>-->
                        <!--                                    <option value="Diploma">{{ getLocalizedText('form_4.diploma') }}</option>-->
                        <!--                                    <option value="Foundation">{{ getLocalizedText('form_4.foundation') }}</option>-->
                        <!--                                    <option value="Degree">{{ getLocalizedText('form_4.degree') }}</option>-->
                        <!--                                    <option value="Masters">{{ getLocalizedText('form_4.masters') }}</option>-->
                        <!--                                    <option value="PhD">{{ getLocalizedText('form_4.phd') }}</option>-->
                        <!--                                    <option value="Other">{{ getLocalizedText('common.other') }}</option>-->
                        <!--                                </select>-->
                        <!--                                <div *ngIf="isFieldInvalid('highest_education')" class="text-red-500 text-sm mt-1">-->
                        <!--                                    {{ getLocalizedText('validation.required') }}-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                        <!-- Educational Details -->
                        <div class="col-span-full pt-6">
                            <label
                                class="mb-4 block text-sm font-medium leading-6 text-gray-900"
                            >
                                {{
                                    getLocalizedText(
                                        'form_4.educationalDetails'
                                    )
                                }}
                            </label>

                            <!-- Level Selection -->
                            <div class="mb-4">
                                <label
                                    for="highest_education"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_4.level') }}
                                </label>
                                <select
                                    id="highest_education"
                                    formControlName="highest_education"
                                    class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                    [ngClass]="{
                                        'ring-red-500':
                                            isFieldInvalid('highest_education'),
                                        'ring-gray-300':
                                            !isFieldInvalid(
                                                'highest_education'
                                            ),
                                    }"
                                >
                                    <option value="">
                                        {{
                                            getLocalizedText(
                                                'common.pleaseSelect'
                                            )
                                        }}
                                    </option>
                                    <option value="Primary">
                                        {{
                                            getLocalizedText(
                                                'form_4.levels.primary'
                                            )
                                        }}
                                    </option>
                                    <option value="Secondary">
                                        {{
                                            getLocalizedText(
                                                'form_4.levels.secondary'
                                            )
                                        }}
                                    </option>
                                    <option value="Polytechnic / College">
                                        {{
                                            getLocalizedText(
                                                'form_4.levels.polytech'
                                            )
                                        }}
                                    </option>
                                    <option value="University">
                                        {{
                                            getLocalizedText(
                                                'form_4.levels.university'
                                            )
                                        }}
                                    </option>
                                    <option
                                        value="Other Academic / Professional Qualifications"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_4.levels.otherQual'
                                            )
                                        }}
                                    </option>
                                    <option value="None">
                                        {{
                                            getLocalizedText(
                                                'form_4.levels.none'
                                            )
                                        }}
                                    </option>
                                </select>
                            </div>

                            <!-- School/Institution -->
                            <div class="mb-4">
                                <label
                                    for="school"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText(
                                            'form_4.schoolInstitution'
                                        )
                                    }}
                                </label>
                                <input
                                    type="text"
                                    id="school"
                                    formControlName="school"
                                    class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                    [ngClass]="{
                                        'ring-red-500':
                                            isFieldInvalid('school'),
                                        'ring-gray-300':
                                            !isFieldInvalid('school'),
                                    }"
                                />
                            </div>

                            <!-- Country -->
                            <div class="mb-4">
                                <label
                                    for="country"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{ getLocalizedText('form_4.country') }}
                                </label>
                                <select
                                    id="country"
                                    formControlName="country"
                                    class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                    [ngClass]="{
                                        'ring-red-500':
                                            isFieldInvalid('country'),
                                        'ring-gray-300':
                                            !isFieldInvalid('country'),
                                    }"
                                >
                                    <option value="Singapore">Singapore</option>
                                    <option value="Malaysia">Malaysia</option>
                                </select>
                            </div>

                            <!-- Date Range -->
                            <div class="mb-4 grid grid-cols-2 gap-4">
                                <div>
                                    <label
                                        for="date_start"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText('form_4.dateStart')
                                        }}
                                    </label>
                                    <!--                                    <input-->
                                    <!--                                        type="date"-->
                                    <!--                                        id="date_start"-->
                                    <!--                                        formControlName="date_start"-->
                                    <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                                    <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('date_start'), 'ring-gray-300': !isFieldInvalid('date_start')}">-->

                                    <div class="mt-2">
                                        <div class="relative">
                                            <input
                                                type="text"
                                                [matDatepicker]="
                                                    dateStartPicker
                                                "
                                                formControlName="date_start"
                                                placeholder="DD/MM/YYYY"
                                                class="block w-full rounded-md border border-gray-300 bg-white p-1.5 text-gray-900"
                                                [ngClass]="{
                                                    'border-red-500':
                                                        isFieldInvalid(
                                                            'date_start'
                                                        ),
                                                    'border-gray-300':
                                                        !isFieldInvalid(
                                                            'date_start'
                                                        ),
                                                }"
                                                (dateChange)="
                                                    onDateInputAll(
                                                        $event.target.value,
                                                        'date_start'
                                                    )
                                                "
                                            />

                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="dateStartPicker"
                                                class="absolute right-2 top-1/2 -translate-y-1/2"
                                            >
                                            </mat-datepicker-toggle>
                                            <mat-datepicker
                                                #dateStartPicker
                                            ></mat-datepicker>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <label
                                        for="date_grad"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText('form_4.dateGrad')
                                        }}
                                    </label>
                                    <!--                                    <input-->
                                    <!--                                        type="date"-->
                                    <!--                                        id="date_grad"-->
                                    <!--                                        formControlName="date_grad"-->
                                    <!--                                        class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"-->
                                    <!--                                        [ngClass]="{'ring-red-500': isFieldInvalid('date_grad'), 'ring-gray-300': !isFieldInvalid('date_grad')}">-->
                                    <div class="mt-2">
                                        <div class="relative">
                                            <input
                                                type="text"
                                                [matDatepicker]="dateGradPicker"
                                                formControlName="date_grad"
                                                placeholder="DD/MM/YYYY"
                                                class="block w-full rounded-md border border-gray-300 bg-white p-1.5 text-gray-900"
                                                [ngClass]="{
                                                    'border-red-500':
                                                        isFieldInvalid(
                                                            'date_grad'
                                                        ),
                                                    'border-gray-300':
                                                        !isFieldInvalid(
                                                            'date_grad'
                                                        ),
                                                }"
                                                (dateChange)="
                                                    onDateInputAll(
                                                        $event.target.value,
                                                        'date_grad'
                                                    )
                                                "
                                            />

                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="dateGradPicker"
                                                class="absolute right-2 top-1/2 -translate-y-1/2"
                                            >
                                            </mat-datepicker-toggle>
                                            <mat-datepicker
                                                #dateGradPicker
                                            ></mat-datepicker>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- High Standard Obtained -->
                            <div class="mb-4">
                                <label
                                    for="high_standard"
                                    class="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_4.highStandard')
                                    }}
                                </label>
                                <select
                                    id="high_standard"
                                    formControlName="high_standard"
                                    class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                    [ngClass]="{
                                        'ring-red-500':
                                            isFieldInvalid('high_standard'),
                                        'ring-gray-300':
                                            !isFieldInvalid('high_standard'),
                                    }"
                                >
                                    <option value="">
                                        {{
                                            getLocalizedText(
                                                'common.pleaseSelect'
                                            )
                                        }}
                                    </option>
                                    <option value="PSLE">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.psle'
                                            )
                                        }}
                                    </option>
                                    <option value="GCE N-Level">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.nLevel'
                                            )
                                        }}
                                    </option>
                                    <option value="GCE O-Level">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.oLevel'
                                            )
                                        }}
                                    </option>
                                    <option value="SPM">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.spm'
                                            )
                                        }}
                                    </option>
                                    <option value="GCE A-Level">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.aLevel'
                                            )
                                        }}
                                    </option>
                                    <option value="Diploma / Specialist">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.diploma'
                                            )
                                        }}
                                    </option>
                                    <option value="Nitec / Higher Nitec">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.nitec'
                                            )
                                        }}
                                    </option>
                                    <option value="STPM">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.stpm'
                                            )
                                        }}
                                    </option>
                                    <option value="Bachelor's Degree">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.bachelors'
                                            )
                                        }}
                                    </option>
                                    <option value="Graduate Diploma">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.gradDiploma'
                                            )
                                        }}
                                    </option>
                                    <option value="Master Degree / MBA">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.masters'
                                            )
                                        }}
                                    </option>
                                    <option value="PhD">
                                        {{
                                            getLocalizedText(
                                                'form_4.standards.phd'
                                            )
                                        }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <br />

                        <!-- Relatives/Friends Working -->
                        <div class="col-span-full mb-8">
                            <label
                                class="mb-2 block text-sm font-medium leading-6 text-gray-900"
                            >
                                {{
                                    getLocalizedText('form_4.workingWithNexus')
                                }}
                            </label>
                            <div class="flex gap-4">
                                <div class="flex items-center gap-x-3">
                                    <input
                                        id="relatives_yes"
                                        formControlName="relatives_in_company"
                                        type="radio"
                                        [value]="1"
                                        class="h-4 w-4"
                                    />
                                    <label for="relatives_yes">{{
                                        getLocalizedText('common.yes')
                                    }}</label>
                                </div>
                                <div class="flex items-center gap-x-3">
                                    <input
                                        id="relatives_no"
                                        formControlName="relatives_in_company"
                                        type="radio"
                                        [value]="0"
                                        class="h-4 w-4"
                                    />
                                    <label for="relatives_no">{{
                                        getLocalizedText('common.no')
                                    }}</label>
                                </div>
                            </div>
                            <div
                                *ngIf="isFieldInvalid('relatives_in_company')"
                                class="mt-1 text-sm text-red-500"
                            >
                                {{ getLocalizedText('validation.required') }}
                            </div>
                        </div>

                        <!-- Relatives Info (Conditional) -->
                        <div
                            class="col-span-full mb-8"
                            *ngIf="showRelativesInfo()"
                        >
                            <label
                                for="relatives_info"
                                class="block text-sm font-medium leading-6 text-gray-900"
                            >
                                {{ getLocalizedText('form_4.yesDetails') }}
                            </label>
                            <div class="mt-2">
                                <textarea
                                    id="relatives_info"
                                    formControlName="relatives_info"
                                    rows="3"
                                    class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset"
                                    [ngClass]="{
                                        'ring-red-500':
                                            isFieldInvalid('relatives_info'),
                                        'ring-gray-300':
                                            !isFieldInvalid('relatives_info'),
                                    }"
                                >
                                </textarea>
                                <div
                                    *ngIf="isFieldInvalid('relatives_info')"
                                    class="mt-1 text-sm text-red-500"
                                >
                                    {{
                                        getLocalizedText('validation.required')
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 flex justify-between">
                    <button
                        type="button"
                        (click)="previousForm()"
                        class="text-sm font-semibold leading-6 text-gray-900"
                    >
                        {{ getLocalizedText('common.previous') }}
                    </button>
                    <button
                        type="button"
                        (click)="nextForm()"
                        class="rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline-0"
                    >
                        {{ getLocalizedText('common.next') }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Form 5 content -->
        <div class="flex justify-center" [ngClass]="getFormClass(4)">
            <form
                [formGroup]="registrationForm"
                class="w-full max-w-xl rounded bg-white p-6 shadow-md md:p-8"
            >
                <div class="space-y-12">
                    <div class="border-b border-gray-900/10 pb-12">
                        <div
                            formGroupName="qna"
                            class="grid grid-cols-1 gap-x-6 gap-y-8"
                        >
                            <!-- QnA Section -->
                            <!-- Suffer from any illness -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.illness') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="illnessYes"
                                            formControlName="any_illness"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="illnessYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="illnessNo"
                                            formControlName="any_illness"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="illnessNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Physical impairment -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.impairment') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="physicalYes"
                                            formControlName="physical"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="physicalYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="physicalNo"
                                            formControlName="physical"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="physicalNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Mental illness / Emotional distress -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_5.mentalIllness')
                                    }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="mentalIllnessYes"
                                            formControlName="mental_illness"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="mentalIllnessYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="mentalIllnessNo"
                                            formControlName="mental_illness"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="mentalIllnessNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Dependent on any prescribed medication -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.medication') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="medicationYes"
                                            formControlName="medication"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="medicationYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="medicationNo"
                                            formControlName="medication"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="medicationNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>

                                <!-- Medication Details (Conditional) -->
                                <div
                                    class="mt-4"
                                    *ngIf="
                                        registrationForm.get('qna.medication')
                                            ?.value === 1
                                    "
                                >
                                    <label
                                        for="medicationDetails"
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {{
                                            getLocalizedText(
                                                'form_5.medicationDetails'
                                            )
                                        }}
                                    </label>
                                    <div class="mt-2">
                                        <input
                                            type="text"
                                            id="medicationDetails"
                                            formControlName="medication_details"
                                            class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Convicted / found guilty -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.convicted') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="convictedYes"
                                            formControlName="found_guilty"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="convictedYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="convictedNo"
                                            formControlName="found_guilty"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="convictedNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Under any form of investigation -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{
                                        getLocalizedText('form_5.investigation')
                                    }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="investigationYes"
                                            formControlName="any_investigation"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="investigationYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="investigationNo"
                                            formControlName="any_investigation"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="investigationNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Objection to undergo medical examination -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.objection') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="objectionYes"
                                            formControlName="objection_undergo"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="objectionYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="objectionNo"
                                            formControlName="objection_undergo"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="objectionNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Alcohol/Drug addiction -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.addiction') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="addictionYes"
                                            formControlName="alcohol_drug_addiction"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="addictionYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="addictionNo"
                                            formControlName="alcohol_drug_addiction"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="addictionNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Undischarged bankrupt -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.bankrupt') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="bankruptYes"
                                            formControlName="undischarged_bankrupt"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="bankruptYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="bankruptNo"
                                            formControlName="undischarged_bankrupt"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="bankruptNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Dismissed or Suspended -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.dismissed') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="dismissedYes"
                                            formControlName="dismissed_or_suspended"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="dismissedYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="dismissedNo"
                                            formControlName="dismissed_or_suspended"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="dismissedNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Business undertaking -->
                            <div class="col-span-full">
                                <legend
                                    class="mb-0 text-sm/6 font-semibold text-gray-900"
                                >
                                    {{ getLocalizedText('form_5.involved') }}
                                </legend>
                                <div class="mt-2 space-y-2">
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="businessYes"
                                            formControlName="business_undertaking"
                                            [value]="1"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="businessYes"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.yes')
                                            }}</label
                                        >
                                    </div>
                                    <div class="flex items-center gap-x-3">
                                        <input
                                            id="businessNo"
                                            formControlName="business_undertaking"
                                            [value]="0"
                                            type="radio"
                                            class="appearance-none not-checked:before:hidden relative size-4 rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full checked:border-indigo-600 checked:bg-indigo-600"
                                        />
                                        <label
                                            for="businessNo"
                                            class="block text-sm/6 font-medium text-gray-900"
                                            >{{
                                                getLocalizedText('common.no')
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- Medication Details (Conditional) -->
                            <!--                            <div class="col-span-full" *ngIf="registrationForm.get('qna.medication')?.value === 1">-->
                            <!--                                    <label for="medicationDetails" class="block text-sm font-medium leading-6 text-gray-900">-->
                            <!--                                        {{ getLocalizedText('form_5.medicationDetails') }}-->
                            <!--                                    </label>-->
                            <!--                                    <div class="mt-2">-->
                            <!--                                        <input type="text"-->
                            <!--                                               id="medicationDetails"-->
                            <!--                                               formControlName="medication_details"-->
                            <!--                                               class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                        </div>
                    </div>

                    <!-- Declaration and Signature - OUTSIDE of qna formGroupName -->
                    <div class="mt-8 grid grid-cols-1 gap-x-6 gap-y-8">
                        <!-- Declaration Checkbox -->
                        <div class="col-span-full">
                            <div class="flex gap-3">
                                <div class="flex h-6 shrink-0 items-center">
                                    <input
                                        id="declaration"
                                        formControlName="declaration"
                                        type="checkbox"
                                        class="appearance-none col-start-1 row-start-1 rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600"
                                    />
                                </div>
                                <div class="text-sm/6">
                                    <p class="mb-0 text-gray-900">
                                        {{
                                            getLocalizedText(
                                                'form_5.declaration'
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Signature Section -->
                        <div class="col-span-full">
                            <h3 class="mb-2 text-sm font-semibold">E-Sign</h3>
                            <canvas
                                #signaturePadCanvas
                                [width]="signaturePadOptions.canvasWidth"
                                [height]="signaturePadOptions.canvasHeight"
                                class="w-full rounded-md border"
                            >
                            </canvas>
                            <div class="mt-2 flex justify-end">
                                <button
                                    type="button"
                                    (click)="clearSignature()"
                                    class="text-sm text-gray-600 hover:text-gray-900"
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Navigation Buttons -->
                <div class="mt-5 flex justify-between">
                    <button
                        type="button"
                        (click)="previousForm()"
                        class="text-sm font-semibold leading-6 text-gray-900"
                    >
                        {{ getLocalizedText('common.previous') }}
                    </button>
                    <button
                        type="button"
                        (click)="generateDocument()"
                        [disabled]="
                            registrationForm.invalid || submitting === true
                        "
                        class="rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline-0"
                    >
                        {{ getLocalizedText('common.submit') }}
                    </button>
                </div>
            </form>
        </div>
    </div>

    <div
        id="popup-success"
        class="invisible flex h-72 w-96 max-w-80 flex-col items-center justify-center rounded bg-slate-100 p-3 shadow-lg"
    >
        <img
            class="w-40"
            src="assets/images/main/bn_settlement_form_popup_success.png"
            alt="Submitted Successfully"
        />
        <h3 class="mb-0 mt-3 text-lg font-bold">
            {{ getLocalizedText('thankYou') }}
        </h3>
        <p>{{ getLocalizedText('message') }}</p>
    </div>

    <div *ngIf="isProceedToBackend" class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Storing Data in backend...</p>
    </div>
</div>
